import { useContext } from 'react'
import { CookiesContext } from 'store/CookiesContext'

export const useCookiesContext = () => {
  const context = useContext(CookiesContext)
  if (!context) throw Error('Missing CookiesContext')
  return context
}
